import React from "react";
import {
  AccessTime,
  Assignment,
  CancelOutlined,
  CheckCircleOutline,
  Person,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useBranchAssignmentContext } from "contexts/BranchAssignmentDetailContext";
import { formatDate } from "utils/dateFormats";

const BranchAssignmentBasicDetail = () => {
  const { branchAssignmentDetail, loadingBranchAssignmentDetail } =
    useBranchAssignmentContext();

  return !loadingBranchAssignmentDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={3}>
                <InformationTile
                  icon={() => <Person color="primary" />}
                  title="User"
                  subtitle={branchAssignmentDetail?.user?.name}
                />
              </Grid>

              <Grid item md={3}>
                <InformationTile
                  icon={() => <Assignment color="primary" />}
                  title="Branch Assignment"
                >
                  {branchAssignmentDetail?.hasCustomAssignment ? "Yes" : "No"}
                </InformationTile>
              </Grid>

              <Grid item md={3}>
                <InformationTile
                  icon={() => <Assignment color="primary" />}
                  title="Assignment Type"
                  subtitle={
                    branchAssignmentDetail?.hasCustomAssignment
                      ? "Branch Assign"
                      : branchAssignmentDetail?.assignmentType === "Region"
                        ? "Province"
                        : branchAssignmentDetail?.assignmentType
                  }
                />
              </Grid>

              <Grid item md={3}>
                <InformationTile
                  icon={() =>
                    branchAssignmentDetail?.status === "Active" ? (
                      <CheckCircleOutline color="primary" />
                    ) : (
                      <CancelOutlined color="primary" />
                    )
                  }
                  title="Status"
                >
                  <div
                    className={`uppercase ${branchAssignmentDetail?.status === "Active"
                        ? "text-green-600"
                        : "text-red-600"
                      }`}
                  >
                    {branchAssignmentDetail?.status}
                  </div>
                </InformationTile>
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Created At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(branchAssignmentDetail?.createdAt)}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default BranchAssignmentBasicDetail;
